import React, { useEffect, useState } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import { useStandard } from "../context/StandardContext";
import axiosInstance from "../services/axiosComman";
import logout from "../utils/Logout";
import Swal from "sweetalert2";
import { HelpIcon, UserProfile } from "../assets/icons";
import { GetAccess, GetUserDetails } from "../utils/RolesandAccess";
import StandardNavLinks from "./StandardNavLinks";

function StandardNavbar() {
  const { standardName, standardId, updateName, updateId } = useStandard();
  const { stdId } = useParams();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!standardName && !standardId) {
      if (stdId) {
        standard();
      }
    }
  }, [standardName, standardId]);

  async function standard() {
    await axiosInstance.get(`Standards/${stdId}`).then((res) => {
      res?.data?.data?.name && updateName(res?.data?.data?.name);
      res?.data?.data?.id && updateId(res?.data?.data?.id);
    }).catch(err=>{
      console.error(err);
    });
  }

  function logOut() {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Log out ?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Logout",
    }).then(async (result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  }

  let { UserImage, Name } = GetUserDetails();


  return (
    <nav className="bg-primary z-50">
      <div className="py-0 lg:py-1 w-11/12 m-auto flex items-center justify-between">
        <div className="md:w-auto w-full flex justify-between">
          <NavLink to="/main/standard">
            <h1 className="text-2xl 2xl:text-3xl text-white font-semibold">
              MetaScroll
            </h1>
          </NavLink>
          <div className="text-3xl md:hidden" onClick={() => setOpen(!open)}>
            <ion-icon name={`${open ? "close" : "menu"}`}></ion-icon>
          </div>
        </div>
        <p className="text-sm w-[30%]  text-center 2xl:text-base text-white font-semibold">
          {standardName || ""}
        </p>
        <ul className="md:flex hidden h-[52px] items-center gap-4">
          <li>
            <NavLink to={`/standard/${standardId}/dashboard`}>
              <svg
                width="22"
                height="24"
                viewBox="0 0 22 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.0135 1.15432C11.6942 0.852498 11.2716 0.684326 10.8322 0.684326C10.3929 0.684326 9.97023 0.852498 9.65098 1.15432L1.32204 9.02589C1.06702 9.26722 0.863952 9.55808 0.725287 9.88064C0.586622 10.2032 0.515278 10.5507 0.515626 10.9018V20.479C0.516082 21.1628 0.788015 21.8184 1.27165 22.3017C1.75529 22.785 2.41104 23.0565 3.09478 23.0565H5.67393C6.35796 23.0565 7.01398 22.7847 7.49767 22.3011C7.98135 21.8174 8.25308 21.1614 8.25308 20.4773V16.1787C8.25308 15.9507 8.34366 15.7321 8.50489 15.5708C8.66612 15.4096 8.88479 15.319 9.1128 15.319H12.5517C12.7797 15.319 12.9984 15.4096 13.1596 15.5708C13.3208 15.7321 13.4114 15.9507 13.4114 16.1787V20.4773C13.4114 21.1614 13.6831 21.8174 14.1668 22.3011C14.6505 22.7847 15.3065 23.0565 15.9905 23.0565H18.5697C19.2537 23.0565 19.9097 22.7847 20.3934 22.3011C20.8771 21.8174 21.1488 21.1614 21.1488 20.4773V10.9001C21.1487 10.5491 21.077 10.2019 20.9381 9.87964C20.7991 9.55738 20.5958 9.26687 20.3407 9.02589L12.0135 1.15088V1.15432Z"
                  fill="white"
                />
              </svg>
            </NavLink>
          </li>
          <StandardNavLinks />
        </ul>
        <Link to={`/help/${stdId}`}>
          <HelpIcon />
        </Link>

        <div className="pl-3 py-1  text-left md:cursor-pointer group relative">
          <a
            href="#!"
            className=" flex items-center group text-white text-xs 2xl:text-sm border-l border-white"
          >
              {UserImage ? (
                <img
                  src={UserImage}
                  alt="#"
                  className="w-7 h-7 mx-2 rounded-full bg-slate-300 object-fill"
                />
              ) : (
                <div className="w-7 h-7 mx-2 rounded-full ">
                  <UserProfile/>
                </div>
              )}

              <p className="mr-1 text-white text-sm 2xl:text-sm capitalize">
                {Name || "-"}
              </p>
          </a>
          <div className="absolute z-50 top-[1.8rem] hidden group-hover:md:block hover:md:block">
            <div className="bg-white shadow-box rounded-md px-1 py-3 grid grid-cols-1 w-24">
              <div>
                {GetAccess("admin_view") && (
                  <>
                    <span className=" px-2 font-light text-xs 2xl:text-sm">
                      Settings :
                    </span>
                    <li className="list-none p-2 hover:bg-navhover rounded-md">
                      <Link
                        to={`/standard/${stdId}/settings/status`}
                        className="text-xs 2xl:text-sm pl-1"
                        // onClick={logOut}
                      >
                        Standard
                      </Link>
                    </li>
                  </>
                )}
                <li className="list-none p-2 hover:bg-navhover rounded-md">
                  <Link
                    to="#!"
                    className="text-xs 2xl:text-sm"
                    onClick={logOut}
                  >
                    Logout
                  </Link>
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default StandardNavbar;
